import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '9f9277a5fea87ebbe135fe0eb56f191932a8498e',
    user: localStorage.getItem('user') || '',
    count: 0,
    itemsPerPage: 100,
    subDomain: '',
    pages: []
  },
  getters: {
    getPages: (state) => state.pages,
    getCount: (state) => state.count,
    getsubDomain: (state) => state.subDomain,
    isAuthenticated (state) {
      return !!state.token
    },
    getUser (state) {
      return state.user
    }
  },
  mutations: {
    SET_PAGES (state, pages) {
      state.pages = pages
    },
    SET_COUNT (state, count) {
      state.count = count
    },
    setToken (state, token) {
      state.token = token
    },
    setsubDomain (state, subDomain) {
      state.subDomain = subDomain
    },
    setUser (state, user) {
      state.user = user
    },
    clearAuthData (state) {
      state.token = null
      state.user = null
    },
    SET_COMPANIES (state, companies) {
      state.companies = companies
      state.companiesBackup = [...companies]
    },
    SET_SEARCH_STORE (state, searchStore) {
      state.searchStore = searchStore
    }
  },
  actions: {
    updaterequestedService ({ commit }, value) {
      commit('setrequestedService', value)
    },
    saveAuthData ({ commit }, { token, user }) {
      commit('setToken', token)
      commit('setUser', user)
    },
    logout ({ commit }) {
      commit('clearAuthData')
    },
    updateSearchStore ({ commit }, searchStore) {
      commit('SET_SEARCH_STORE', searchStore)
    },
    // Action to restore stores from backup or filter based on search term
    filterStores ({ commit, state }) {
      if (!state.searchStore) {
        commit('SET_STORES', [...state.storesBackup]) // Reset to original stores
      } else {
        const filteredStores = state.storesBackup.filter(store => {
          return store.name_ar.toLowerCase().includes(state.searchStore.toLowerCase())
        })
        commit('SET_STORES', filteredStores)
      }
    }
  },
  modules: {
  }
})
